import * as components from './components'
import * as hooks from './hooks'
import * as types from './types'

console.log('Dependencies feature initialized!')

export { components, hooks, types }
